// src/theme/themes.js
import { createTheme } from '@mui/material/styles';

// ============================================
// الثيم 1: الوردي الحيوي (Vibrant Pink)
// ============================================
export const vibrantPinkTheme = createTheme({
  palette: {
    primary: {
      main: '#FF1493',
      light: '#FF69B4',
      dark: '#C71585',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#4A00E0',
      light: '#7B2FBE',
      dark: '#2E005E',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFF0F5',
      paper: 'rgba(255, 255, 255, 0.92)',
    },
    text: {
      primary: '#1A0A1A',
      secondary: '#4A148C',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Segoe UI", Arial, sans-serif',
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(135deg, #FF1493, #FF69B4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #C71585, #FF1493)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #4A00E0, #7B2FBE)',
          '&:hover': {
            background: 'linear-gradient(135deg, #2E005E, #4A00E0)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 105, 180, 0.2)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(16px)',
          borderBottom: '2px solid rgba(255, 105, 180, 0.2)',
        },
      },
    },
  },
});

// ============================================
// الثيم 2: الوردي الناعم (Soft Blush)
// ============================================
export const softBlushTheme = createTheme({
  palette: {
    primary: {
      main: '#F06292',
      light: '#F8BBD0',
      dark: '#AD1457',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#6A1B4D',
      light: '#8E24AA',
      dark: '#4A148C',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FCE4EC',
      paper: 'rgba(255, 255, 255, 0.90)',
    },
    text: {
      primary: '#3E1A2E',
      secondary: '#6A1B4D',
    },
  },
  typography: {
    fontFamily: '"Quicksand", "Segoe UI", Arial, sans-serif',
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(135deg, #F06292, #AD1457)',
          '&:hover': {
            background: 'linear-gradient(135deg, #EC407A, #880E4F)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #6A1B4D, #4A148C)',
          '&:hover': {
            background: 'linear-gradient(135deg, #4A148C, #311B92)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.80)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(240, 98, 146, 0.15)',
          borderRadius: 20,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.90)',
          backdropFilter: 'blur(16px)',
          borderBottom: '2px solid rgba(240, 98, 146, 0.15)',
        },
      },
    },
  },
});

// ============================================
// الثيم 3: الليلي الأنيق (Midnight Elegance)
// ============================================
export const midnightTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF1493',
      light: '#FF69B4',
      dark: '#C71585',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#4A00E0',
      light: '#7B2FBE',
      dark: '#2E005E',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#0A0A0A',
      paper: 'rgba(26, 10, 26, 0.92)',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#FF69B4',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Segoe UI", Arial, sans-serif',
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(135deg, #FF1493, #FF69B4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #C71585, #FF1493)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #4A00E0, #7B2FBE)',
          '&:hover': {
            background: 'linear-gradient(135deg, #2E005E, #4A00E0)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(26, 10, 26, 0.85)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 20, 147, 0.15)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(10, 10, 10, 0.92)',
          backdropFilter: 'blur(16px)',
          borderBottom: '2px solid rgba(255, 20, 147, 0.2)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'rgba(26, 10, 26, 0.85)',
          backdropFilter: 'blur(12px)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: '#FF69B4',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FF1493',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.7)',
            '&.Mui-focused': {
              color: '#FF69B4',
            },
          },
          '& .MuiInputBase-input': {
            color: '#FFFFFF',
          },
        },
      },
    },
  },
});

// قائمة الثيمات المتاحة
export const themes = {
  vibrantPink: {
    id: 'vibrantPink',
    name: 'الوردي الحيوي',
    nameEn: 'Vibrant Pink',
    icon: '🌸',
    theme: vibrantPinkTheme,
    colors: {
      primary: '#FF1493',
      secondary: '#4A00E0',
      background: '#FFF0F5',
    },
  },
  softBlush: {
    id: 'softBlush',
    name: 'الوردي الناعم',
    nameEn: 'Soft Blush',
    icon: '🌷',
    theme: softBlushTheme,
    colors: {
      primary: '#F06292',
      secondary: '#6A1B4D',
      background: '#FCE4EC',
    },
  },
  midnight: {
    id: 'midnight',
    name: 'الليلي الأنيق',
    nameEn: 'Midnight Elegance',
    icon: '🌙',
    theme: midnightTheme,
    colors: {
      primary: '#FF1493',
      secondary: '#4A00E0',
      background: '#0A0A0A',
    },
  },
};

export default themes;
